<!--设备台账-->
<template>
  <div class="newarchives">
      <div class="con">
          <div class="tree-left">
                <div style="margin-bottom: 5px;">
                    <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
                </div>
                 <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
                        <el-tree class="filter-tree" :data="archivesGroupTree" 
                            :expand-on-click-node="true" 
                            node-key="id" :props="defaultPropsleft" :highlight-current='true' :filter-node-method="filterNode" ref="tree" @node-click="checkItem"
                        >
                        <template #default="{ node }">
                            <span class="custom-tree-node">
                                <img src="../../../public/static/image/elTree/1.9.png"/>    
                                {{ node.label }}
                            </span>
                        </template>
                        </el-tree>
                </el-scrollbar>
          </div>
          <div class="middle-tree">
               <div style="margin-bottom: 5px;">
                    <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterTexts"> </el-input>
                </div>
               <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
                  <el-tree :data="archivesTypeList"  :expand-on-click-node="true" node-key="id"
                  :filter-node-method="filterNodes"
                    :props="defaultProps" :highlight-current='true' ref="trees" @node-click="nodeClick_archives">
                    <span class="custom-tree-node" slot-scope="{node}">
                      <img src="../../../public/static/image/elTree/2.0.png" />
                      <span style="padding:0px  5px;">{{node.label }}</span>
                    </span>
                  </el-tree>
                </el-scrollbar>
          </div>
          <div class="right-table">
               <div class="Files-top">
                    <div class="ic-left">
                    <span>设备管理</span>
                    </div>
                    <div class="btns">
                       <el-button type="danger"  @click="batchDeletion" class="del-btn">批量删除</el-button>
                       <el-button type="primary" @click="add_fn"  v-show="typeEnum == 1">添加</el-button>
                        <el-button type="primary"  v-if="archivesList.length > 0" @click="getQRCodeAppEquipInfo" class="last-el-button">导出设备二维码</el-button>

                    </div>
              </div>
                <div class="search-input-btn" style="width:100%">
                    <div class="input-small">
                    <span>名称：</span>
                      <el-input v-model="search" clearable placeholder="请输入名称"></el-input>
                    </div>
                    <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
				     	</div>
              <div class="my-table" :style="{'height':heights+'px'}">
                 <el-table :data="archivesList"
                 v-loading="loading"
                     style="width: 100%" @selection-change="handleSelectionChange" @cell-mouse-enter="selectColumn" stripe :height="heights - 20">
                    <template slot="empty">
                      <span class="noData">
                        <img src="@/assets/noData.png" alt="暂无数据">
                        <span class="text">暂无数据</span>
                      </span>
                    </template>
                    <el-table-column type="index" label="序号" width="90" align="center">
                    </el-table-column>
                    <el-table-column type="selection" width="44" align="center">
                    </el-table-column>
                    <el-table-column label="名称" prop="name" align="center" width='180'>
                    </el-table-column>
                    <el-table-column label="类型" prop="typeName" align="center" width='180'>
                    </el-table-column>
                    <el-table-column label="关联设备" prop="virtualDeviceName" align="center" width='180'>
                    </el-table-column>
                    <el-table-column label="创建时间" prop="createTime" :formatter="formatTime" align="center" width='180'> 
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width='180' align="center">
                      <template #default="{row}">
                      
                         <div class="public-flex">
                            <div @click="editColumn(row)" class="mr-20">
                              <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                <elIconBtn btnType='edit'></elIconBtn>
                              </el-tooltip>
                            </div>
                            <div @click="deleteColumn(row)">
                              <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <elIconBtn btnType='del'></elIconBtn>
                              </el-tooltip>
                            </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
              </div>
              <div class="divider-line"></div>
              <div class="paging">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                  :current-page="pageIndex" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
                  layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
              </div>
          </div>
           <!--添加台账弹窗-->
    <el-dialog width="40%" title="添加台账" :visible.sync="addContentFormShow" append-to-body v-dialogDrag>
      <!--设备树-->
      <div style="display: flex;">
        <div class="device-tree">
          <elRadioTree :dataList='virtualDeviceList'></elRadioTree>
        </div>
        <el-form :model="form" ref="form"
          style="border: 1px solid #ded7d7;width: 80%;height: 550px;overflow: auto;">
          <el-form-item label="台账名称" prop="name" label-width="120px"
            :rules="[{ required: true, message: '名称不能为空', trigger: 'blur' }]" style="margin-top: 10px;">
            <el-input v-model="form.name" autocomplete="off" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="绑定设备" prop="deviceName" label-width="120px"
            :rules="[{ required: true, message: '必须绑定一个设备', trigger: 'blur' }]">
            <el-input v-model="form.deviceName" placeholder="请选择设备" :disabled="true" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item :label="item.propertyName" label-width="120px" v-for="(item,index) in propertyList.property"
            :key="index">
            <el-input v-model="form[item.typePropertyCode]" autocomplete="off" style="width:90% ;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addContentFormShow = false">取 消</el-button>
        <el-button type="primary" @click="determine()">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑弹窗-->
    <el-dialog width="40%" title="编辑台账" :visible.sync="editShow" append-to-body v-dialogDrag>
      <div style="display: flex;">
        <div class="device-tree">
          <elRadioTree :dataList='virtualDeviceList' ref="elradiotree"></elRadioTree>
        </div>
        <el-form :model="editFrom" ref="editFrom"
          style="border: 1px solid #ded7d7;width: 80%;height: 550px;">
          <el-scrollbar style="height:98%;width: 100%;">
            <el-form-item label="台账名称" prop="name" label-width="135px"
              :rules="[{ required: true, message: '名称不能为空', trigger: 'blur' }]" style="margin-top: 10px;">
              <el-input v-model="editFrom.name" autocomplete="off" style="width: 90%;"></el-input>
            </el-form-item>
            <el-form-item label="绑定设备" :rules="[{ required: true, message: '必须绑定一个设备', trigger: 'blur' }]"
              prop="deviceName" label-width="135px">
              <el-input v-model="editFrom.deviceName" placeholder="请选择设备" :disabled="true"
                style="width: 90%;"></el-input>
            </el-form-item>
            <el-form-item :label="item.propertyName" label-width="135px" v-for="(item,index) in editData.property"
              :key="index">
              <el-input v-model="editFrom[item.typePropertyCode]" @input="change($event)"
                style="width:90% ;"></el-input>
            </el-form-item>
          </el-scrollbar>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editShow = false">取 消</el-button>
        <el-button type="primary" @click="editConfirm()">保存</el-button>
      </div>
    </el-dialog>


      </div>
   
  </div>
</template>

<script type="text/javascript">
  import elArchivesDeviceTree from '@/components/module/tree/elArchivesDeviceTree.vue'
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
   import elIconBtn from '@/components/module/iconBtns.vue'
  import {existsByDeviceNo} from "../../api/abbNewApi"
  export default {
    components: {
      elArchivesDeviceTree,
      elRadioTree,
      elCheckBoxTree,
      elIconBtn
    },
    props: [],
    data () {
      return {
        loading:false,
        heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        filterText:"",
        filterTexts:"",
        typeEnum: 0,
        nowGroup: undefined,
        search: '', //过滤
        archivesList: [], //台账列表
        pageIndex: 1,
        size: 10,
        total: 0,
       
        formLabelWidth: '120px',
        addShow: false,
        firstLevel: '', //选中第一级的数据
        firstLevelList: [],
        secondLevel: '', //第二级的数据
        secondLevelList: [],
        thirdLevel: '', //第三级的数据
        thirdLevelList: [],
        fourthLevel: '', //第四级的数据
        addContentFormShow: false,
        propertyList: [], //选中的台账信息
        form: {
          name: '',
          deviceName: '',
        },
        selectDevice: {},
        selectItemList: [], //选中多个
        editShow: false,
        editFrom: {
          name: '',
          deviceName: '',
          deviceNo: '',
        },
        defaultPropsleft: {
          children: 'children',
          label: 'label'
        },
        defaultProps: {
          children: 'next',
          label: 'typeName'
        },
        editData: {}, //选中的数据
        nowTypePropertyList: {},
        archivesListCopy:[],

      }
    },
    created () {
      debugPage=this
      this.$store.archivesStore.commit("getEntityTypeList")
    },
    mounted () {
      this.initData()
    },
    destroyed () {},
    computed: {
      archivesTypeList () {
        var data=this.$store.archivesStore.getters.getArchivesTypeList
        return data;
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      margigStyle () {
        if(this.archivesList.length<=0) {
          return {'margin-right': '0px'}
        }
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      getEntityTypeList () {
        let list=this.$store.archivesStore.getters.getArchivesTypeList
        return isempty(list)? []:list
      },
      nowVirtualDevice () {
        return this.$store.deviceStore.state.nowVirtualDevice
      },
      nowUnitArchivesTree () {
        //当前单位可以查看的台账设备树
        if(isempty(this.nowUnit)) {
          return undefined
        }
        return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
      },
      archivesGroupTree () {
        if(this.nowUnitArchivesTree==undefined) {
          return []
        }
        //过滤掉设备
        let list=filterTreeRecursive([copy(this.nowUnitArchivesTree)],(item) => {
          return item.entityName=='AppClassType'
        })
        if(!isempty(list)) {
          this.nowGroup=deviceList(list)[0]
          // this.leftID = this.nowGroup.id
            this.$nextTick(() => {
            this.$refs['tree'].setCurrentKey(this.nowGroup.id)
          })
        }
      
        return deviceList(list)
      },
      nowArchivesTypeTree () {
        //要显示当前层级的数量
        var countMap=this.nowGroup==undefined? {}:this.nowGroup.archivesCountMap
        var filterList=list => {
          var nList=[]
          for(var i=0,len=list.length;i<len;i++) {
            var item=list[i]
            if(item.entityName=='MisEntityType') {
              item.typeName=item.typeName+'('+(countMap.hasOwnProperty(item.typeCode)?
                countMap[item.typeCode]:0)+')'
              nList.push(item)
            }
          }
          return nList
        }
        return filterList(copy(this.$store.archivesStore.getters.getArchivesTypeList))
      },
    },
    watch: {
      addShow (nv,ov) {
        if(nv) {
          $(".elTree_hideButton1").css("display","none");
        } else {
          $(".elTree_hideButton1").css("display","block");
        }
      },
      archivesGroupTree (nv,ov) {
        this.initData()
      },

      nowVirtualDevice (nv,ov) {
        //选中设备后
        if(!isempty(nv)) {
          existsByDeviceNo({'deviceNo': nv.no}).then(res => {
            if(res.data) {
              this.$message({type: 'warning',message: `${nv.name} 已绑定，请选择其他设备！！`});
            } else {
              this.form.deviceNo=nv.no
              this.form.deviceName=nv.label
              this.editFrom.deviceName=nv.label
              this.editFrom.deviceNo=nv.no
            }
          })

        }
      },
      // pageIndex (nv,ov) {
      //   this.initData()
      // },
       filterText(val) {
        this.$refs.tree.filter(val);
      },
       filterTexts(val) {
        this.$refs.trees.filter(val);
      },
     
     

    },
    methods: {
       //分页功能 
      handleSizeChange (val) {
        this.size=val;
        this.initData()
      },
      handleCurrentChange (val) {
        this.pageIndex=val;
        this.initData()
      },
      search_fn(){
        this.archivesList =  this.archivesListCopy.filter(data => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()))
      },
       // 树形筛选
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
         // 树形筛选
        filterNodes(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
      checkItem (val) {
        
        this.$nextTick(() => {
          this.$refs['trees'].setCurrentKey(null)
        })
        this.nowGroup=val
        this.initData()

      },
      nodeClick_archives (val) {

        this.propertyList=val
        this.typeEnum=val.typeEnum
        this.loading = true
        this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(val.id,this.nowGroup.no,respon => {
          this.total=respon.length
          this.archivesListCopy = JSON.parse(JSON.stringify(respon))
          this.archivesList=respon
          this.loading = false
        })
      },
      add_fn () {
        this.$api.entityApi.getTypePropertyList(this.propertyList.typeCode,respon => {
          this.propertyList.property=respon
          this.addContentFormShow=true
        })
      },
      initData () {
        //初始化数据
        if(isempty(this.archivesGroupTree)) {
          return
        }
        this.$api.archivesApi.getArchivesList(this.nowGroup.no,this.pageIndex,this.size,respon => {

          this.total=respon.total
          this.archivesList=respon.dataList
        })
      },
      initData_fn () {
        this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.propertyList.id,this.nowGroup.no,respon => {
          this.total=respon.length
          this.archivesList=respon
        })
      },
      getQRCodeAppEquipInfo () {
        if(isempty(this.nowGroup.no)&&isempty(this.nowGroup.label)) {
          return
        }
        this.$api.archivesApi.getQRCodeAppEquipInfo(this.nowGroup.no,this.nowGroup.label,respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,this.nowGroup.label+"-设备信息.xls")
        })
      },
      change (e) {
        this.$forceUpdate()
      },
      addArchives (item) {
        //添加台账
        this.propertyList=item
        this.$api.entityApi.getTypePropertyList(item.typeCode,respon => {
          this.propertyList.property=respon
          this.addContentFormShow=true
        })
      },
      handleClick () {
        //选中第一级
        //debugger
        this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.firstLevel,this.nowGroup.no,respon => {
          this.firstLevelList=respon
        })

      },
      soconHandleClick () {
        //选中第二级
        this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.secondLevel,this.nowGroup.no,respon => {
          this.secondLevelList=respon
        })
      },
      thirdHandleClick () {
        //选中第三级
        this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.thirdLevel,this.nowGroup.no,respon => {
          this.thirdLevelList=respon
        })
      },
      deviceCheckItem (value) {
        existsByDeviceNo({'deviceNo': value.no}).then(res => {
          if(res.data) {
            this.$message({
              type: 'warning',

              message: `${value.name} 已绑定，请选择其他设备！！`
            });
          } else {
            this.form.deviceName=value.label
            this.form.deviceNo=value.no
          }
        })

      },
      determine () {
        //确认添加
        this.$refs.form.validate((valid) => {
          if(valid) {
            let archivesInfo={
              "id": "",
              "name": this.form.name,
              "typeCode": this.propertyList.typeCode,
              "groupId": this.nowGroup.no,
              "unitid": this.nowGroup.unitid,
              "property": [],
              "next": [],
              "deviceNo": this.nowVirtualDevice.no
            }
            //定义台账属性值添加进去
            this.propertyList.property.forEach(item => {
              let obj={
                "propertyCode": item.typePropertyCode,
                "value": this.form[item.typePropertyCode]
              }
              archivesInfo.property.push(obj)
            })
            //debugger
            this.$api.archivesApi.saveArchivesInfo(JSON.stringify(archivesInfo),
              respon => {
                if(!isempty(respon)) {
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  this.form={
                    name: '',
                    deviceName: '',
                  }
                  this.initData_fn()
                  this.addContentFormShow=false
                }
              },err => {
                this.$message({
                  type: 'error',
                  message: err
                });
              })
          } else {
            return false
          }
        })
      },
      editConfirm () {
        //确认编辑
        this.$refs.editFrom.validate((valid) => {
          if(valid) {
            let archivesInfo={
              "id": this.editData.id,
              "name": this.editFrom.name,
              "typeCode": this.editData.typeCode,
              "groupId": this.editData.groupId,
              "property": [],
              "next": [],
              "deviceNo": this.editFrom.deviceNo
            }
            this.editData.property.forEach(item => {
              let obj={
                "propertyCode": item.typePropertyCode,
                "value": this.editFrom[item.typePropertyCode]
              }
              archivesInfo.property.push(obj)
            })
            this.$api.archivesApi.saveArchivesInfo(JSON.stringify(archivesInfo),
              respon => {
                if(!isempty(respon)) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                  this.initData_fn()
                  this.editShow=false
                }
              },err => {
                this.$message({
                  type: 'error',
                  message: err
                });
              })
          } else {
            return false
          }
        })
      },
      handleSelectionChange (val) {
        this.selectItemList=val
      },
      editColumn (item) {
        //编辑台账付初始值
        this.editFrom.name=item.name
        this.editFrom.deviceName=item.virtualDeviceName
        this.editFrom.deviceNo=item.virtualDeviceNo

        // this.$refs.elradiotree.setNowDefaultDevice(12)
        this.$api.archivesApi.getPropertyValueTree(item.id,respon => {
          this.editData=respon
          if(!isempty(respon.property)) {
            respon.property.forEach(item => {
              this.editFrom[item.typePropertyCode]=item.value
            })
          }
          this.editShow=true
          if(this.editShow) {
            this.$nextTick(() => {
              this.$refs.elradiotree.setNowDefaultDevice(this.editFrom.deviceNo)
            })
          }

        })
      },
      selectColumn () {},
      batchDeletion () {
        //批量删除
        if(isempty(this.selectItemList)) {
          this.$message({
            message: '请选中数据',
            type: 'warning'
          });
          return
        }
        let pkids=''
        this.selectItemList.forEach((item,index) => {
          if(index+1==this.selectItemList.length) {
            pkids+=item.id
          } else {
            pkids+=item.id+','
          }
        })
        this.$alert('','确定删除选中的数据吗？',{
          confirmButtonText: '确定',
          callback: action => {
            this.$api.archivesApi.deleteArchives(pkids,respon => {
              if(!isempty(respon)) {
                this.initData()
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
              }
            })
          }
        });
      },
      deleteColumn (data) {
        //单个删除
        this.$confirm('确定删除此项, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.archivesApi.deleteArchives(data.id,respon => {
            if(!isempty(respon)) {
              this.initData_fn()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      prevClick () {
        //上一页
        if(this.pageIndex==1) {
          this.$message('当前为第一页');
          return
        }
        this.pageIndex-=1
      },
      clickChange (index) {
        this.pageIndex=index
        //点击页数
      },
      nextClick () {
        if(this.pageIndex==Math.ceil(this.total/this.size)) {
          this.$message('当前为最后一页');
          return
        }
        this.pageIndex+=1
      },
      formatTime (row,column,cellValue) {
        return new Date(row.createTime).format('yyyy-MM-dd')
      },
    }
  }
</script>
<style scoped lang="scss">
/deep/.el_Tree_Body {
   height: 550px !important;
}
.public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
      }
    .newarchives {
       .con {
         width: 100%;
         height: 100%;
         box-sizing: border-box;
         display: flex;
         .tree-left {
            width: 300px;
            height: 100%;
            padding: 12px;
            box-sizing: border-box;
            background-color: #fff;

         }
         .middle-tree {
             width: 300px;
            height: 100%;
            padding: 12px;
            box-sizing: border-box;
            background-color: #fff;
            margin: 0px 8px;
         }
         .right-table {
            width: calc(100% - 616px);
            height: 100%;
            background-color: #fff;
            padding: 12px 20px;
            box-sizing: border-box;
         }
          .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }
      }
    }
</style>